
    export const Orders = {
        LOADING_ORDERS_LIST: "LOADING_ORDERS_LIST",
        GET_ORDERS_LIST: "GET_ORDERS_LIST",
      };

